import { EXPIRED_SESSION_KEY } from '../constants/expiredSessionKey';

export const isExpiredSessionBannerEnabled = () =>
  typeof window !== 'undefined' ? !!window.sessionStorage.getItem(EXPIRED_SESSION_KEY) : false;
